import { createAction, createReducer } from '@reduxjs/toolkit';
import { FeedApiResponse } from 'reactApp/modules/feed/feed.types';
import { isFolder } from 'reactApp/modules/file/utils';
import { addFilesSuccess, removeFileSuccess } from 'reactApp/modules/modifying/modifying.actions';

import { EAllDocumentsType, IAllDocumentsState } from './allDocuments.types';

export const allDocumentsLoadRequest = createAction<EAllDocumentsType | undefined>('allDocuments/loadRequest');
export const allDocumentsMoreRequest = createAction('allDocuments/loadMoreRequest');
export const allDocumentsLoadStart = createAction('allDocuments/loadStart');
export const allDocumentsLoadSuccess =
    createAction<{ type: EAllDocumentsType | undefined | null; data?: FeedApiResponse; items: string[] }>('allDocuments/loadSuccess');
export const allDocumentsLoadError = createAction<{ type: EAllDocumentsType | undefined | null; error: string }>('allDocuments/loadError');
export const resetCurrentAllDocumentType = createAction('allDocuments/resetCurrentAllDocumentType');

const initialState: IAllDocumentsState = {
    currentDocType: EAllDocumentsType.document,
    isLoaded: false,
    isLoading: false,
    hasMoreToLoad: false,
    cursor: '',
    idxs: [],
};

export const allDocumentsReducer = createReducer(initialState, {
    [allDocumentsLoadRequest.type]: (state, action: ReturnType<typeof allDocumentsLoadRequest>) => {
        state.isLoaded = false;
        state.isLoading = true;
        state.currentDocType = action.payload || EAllDocumentsType.document;
        state.error = '';
        state.idxs = [];
    },
    [allDocumentsLoadSuccess.type]: (state, action: ReturnType<typeof allDocumentsLoadSuccess>) => {
        const { type, data, items } = action.payload;

        if (type === state.currentDocType) {
            state.isLoaded = true;
            state.isLoading = false;

            state.cursor = data?.cursor || '';
            state.hasMoreToLoad = !!data?.cursor;
            state.idxs = [...state.idxs, ...items];
        }
    },
    [allDocumentsLoadError.type]: (state, action: ReturnType<typeof allDocumentsLoadError>) => {
        if (action.payload.type === state.currentDocType) {
            state.isLoaded = true;
            state.isLoading = false;
            state.error = action.payload.error;
        }
    },
    [resetCurrentAllDocumentType.type]: (state) => {
        state.currentDocType = null;
    },
    [removeFileSuccess.type]: (state, action: ReturnType<typeof removeFileSuccess>) => {
        const { ids } = action.payload;
        state.idxs = state.idxs.filter((id) => !ids.includes(id));
    },
    [addFilesSuccess.type]: (state, action: ReturnType<typeof addFilesSuccess>) => {
        const { items } = action.payload;
        items.forEach((item) => !isFolder(item) && state.idxs.unshift(item.id));
    },
});
